import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=7ef28d9a&"
import script from "./EmailTemplate.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports